import { useState } from "react";
import { CalendarRange } from "lucide-react";
import { shiftDate, todayJkt } from "@/lib/api";
import ReportView from "@/components/ReportView";

const weekOf = (s) => {
  const dow = (new Date(`${s}T00:00:00Z`).getUTCDay() + 6) % 7;
  const start = shiftDate(s, -dow);
  return [start, shiftDate(start, 6)];
};

export default function RekapMingguan() {
  const [day, setDay] = useState(todayJkt());
  const range = weekOf(day || todayJkt());
  const picker = (
    <div className="flex items-center gap-1">
      <button className="jt-btn jt-btn-ghost px-3" onClick={() => setDay(shiftDate(range[0], -7))} aria-label="Minggu sebelumnya" data-testid="week-prev-button">‹</button>
      <input type="date" className="jt-input w-44" value={day} onChange={(e) => setDay(e.target.value)} aria-label="Pilih tanggal dalam minggu" data-testid="week-date-input" />
      <button className="jt-btn jt-btn-ghost px-3" onClick={() => setDay(shiftDate(range[0], 7))} aria-label="Minggu berikutnya" data-testid="week-next-button">›</button>
    </div>
  );
  return <ReportView title="Rekap Mingguan" subtitle="Ringkasan uang, kasbon, dan stok selama satu minggu (Senin–Minggu)." icon={CalendarRange} range={range} picker={picker} />;
}
